import styled from "styled-components";

export const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    overflow: "hidden" .seat-content {
        display: flex;
        justify-content: center;
        overflow-x: scroll;
    }

    .container {
        margin: 50px 0;
    }

    .card {
        width: 100%;
        border: none;
    }

    .position {
        font-size: 30px;
        font-weight: 600;
    }

    .name {
        font-size: 24px;
        font-weight: 700;
        text-align: center;
    }

    .link {
        font-size: 24px;
        font-weight: 500;
        font-style: normal;
    }

    .id {
        font-size: 30px;
        font-weight: 500;
        font-style: normal;
    }

    .footer {
        position: absolute;
        bottom: 10;
        max-width: 95%;
    }

    .row {
        display: flex;
        justify-content: space-between;
    }

    .info {
        font-size: 18px;
        font-weight: 500;
        font-style: normal;
        text-align: justify;

        .company {
            font-size: 16px;
            font-style: italic;
        }

        .role {
            font-weight: 600;
        }
    }
`;
